<template>
	<div class="TemplateName" >
		<input v-model="name" ref="input" placeholder="Enter a name to save" />
	</div>
</template>

<script>

	export default {

		props : ['value'],

		data(){
			return {
				name : '',
			}
		},

		watch: {
			value : function(){
				this.name = (this.value||{}).name || '';
			},
			name : function(){
				this.$emit('input', this.templateVal() )
			},
		},

		beforeMount(){
			this.name = (this.value||{}).name || '';
		},

		methods:{
			templateVal(){
				return Object.assign({},this.value,{
					name : this.name,
				})
			},
		}
	}

</script>